import { ACHIEVEMENTS_FETCHED } from "../actions/achievements";

export default (state = null, action = {}) => {
  switch (action.type) {
    case ACHIEVEMENTS_FETCHED:
      return action.payload;

    default:
      return state;
  }
};
